import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-nav-header, [glxyNavHeader]',
  standalone: false,
})
export class GalaxyNavHeaderDirective {
  @HostBinding('class') class = 'glxy-nav-header';
}
